import type { EncodeUriExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const encodeURIResolver =
  createSimpleNamedExpressionResolver<EncodeUriExpression>(
    'encodeURI',
    encodeURI
  );
